export default "__VITE_ASSET__BhZOAhi6__"